import React, { FC } from 'react';

import { TableCell } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { CellProps } from '../../../const';

const LinkCell: FC<CellProps> = ({ row, k, styles, align }) => {
  const link = row[k]?.link;
  const href = row?.video ? `/${link}/` : `/pathway/${link}/`;

  return (
    <TableCell key={k} className={styles.contentCell} align={align}>
      <Link className={styles.tableLink} to={href}>
        {row[k]?.label}
      </Link>
    </TableCell>
  );
};

export default LinkCell;
